module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label",
    class: _vm.classes
  }, [_vm._v("\n  " + _vm._s(_vm.stateForHuman) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ed3ce1a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PaymentState.vue
// module id = 450
// module chunks = 1